/**
 * Created by hinrich on 16.02.16.
 */

var _tabs = document.getElementsByClassName('tab');
var _firstDay = document.getElementsByClassName('day-hourly')[0];
var _body = document.body || document.getElementsByTagName('body')[0];
var isRtl = _body.className.indexOf('rtl') > -1;
var currentDay = 0;
var interval = null;

function moveTo(day) {
    if (0 <= day && _tabs.length > day) {
        var margin = (-100 * day) + "%";
        if (isRtl) {
            _firstDay.style.marginRight = margin;
        } else {
            _firstDay.style.marginLeft = margin;
        }

        for (var i = 0; i < _tabs.length; i++) {
            //Array.prototype.forEach.call(_tabs, function (_tab) {
            //_tab.classList.remove('active');
            _tabs[i].className = _tabs[i].className.replace('active', '');
        }

        //_tabs[day].classList.add('active');
        _tabs[day].className += ' active';
        currentDay = parseInt(day, 10);
        return true;
    } else {
        return false;
    }
}

for (var i = 0; i < _tabs.length; i++) {
    _tabs[i].addEventListener('click', function () {
        clearInterval(interval);
        var d = this.hasOwnProperty('dataset') ? this.dataset.day : this.getAttribute('data-day');
        moveTo(d);
    });
}

_body.addEventListener('keydown', function (e) {
    switch (e.keyCode) {
        case 37:
            clearInterval(interval);
            if (isRtl) {
                moveTo(currentDay + 1);
            } else {
                moveTo(currentDay - 1);
            }
            return false;
        case 39:
            clearInterval(interval);
            if (isRtl) {
                moveTo(currentDay - 1);
            } else {
                moveTo(currentDay + 1);
            }
            return false;
        default:
            return true;
    }
});

window.addEventListener('load', function load() {
    window.removeEventListener('load', load, false);
    var _hourly = document.getElementById('hourly');
    var _pictos = document.getElementsByClassName('picto');
    for (var i = 0; i < _pictos.length; i++) {
        if (_hourly.offsetWidth < _pictos[i].offsetWidth) {
            var _descriptions = _pictos[i].querySelectorAll('.description');
            for (var j = 0; j < _descriptions.length; j++) {
                _descriptions[j].style.display = 'none';
            }
        }
    }

    var parameters = location.search.match(/slideshow=([0-9]+)/i);
    if (null !== parameters && parameters.length > 1 && parseInt(parameters[1], 10) > 2999) {
        interval = setInterval(function () {
            if (!moveTo(currentDay + 1)) {
                moveTo(0);
            }
        }, parseInt(parameters[1], 10));
    }
}, false);

var overlay = function (callback) {
    var _overlay = document.createElement('div');
    _overlay.className = 'overlay';
    _overlay.style.opacity = 0;
    _overlay.style.zIndex = -1;
    _body.appendChild(_overlay);

    _overlay.onclick = function () {
        close();
        if ('function' === typeof callback) {
            callback.apply();
        }
    };

    var close = function () {
        _overlay.style.opacity = 0;
        _overlay.style.zIndex = -1;
    };

    return {
        open: function () {
            _overlay.style.zIndex = 1;
            _overlay.style.opacity = 1;
        },
        close: close,
        setCallback: function (c) {
            callback = c;
        }
    };
};

function loadScript(src, callback) {
    var _script = document.createElement('script');
    var _head = document.head || document.getElementsByTagName('head')[0];
    _script.type = 'text/javascript';
    if (callback) {
        _script.onload = callback;
    }
    _head.appendChild(_script);
    _script.src = src;
}

window.mb = window.mb || {};
window.mb.search = mb.search || {};
window.mb.search.overlay = new overlay();
window.mb.search.proxy = function (callback) {
    if (mb.search.hasOwnProperty('wrapper')) {
        if ('function' === typeof callback) {
            callback.apply();
        }
    } else {
        import(/* webpackChunkName: "search" */ '../modules/search').then((locationsearch) => {
            window.mb.search.search = locationsearch.search({
                showLatLon: false,
                showCountryName: true,
                itemsPerPage: 5
            });
            window.mb.search.wrapper = locationsearch.wrapper(document.getElementById('locationform'), window.mb.search.search, {
                showMap: false,
                onLocationSelect: function (loc) {
                    var url = mb.settings.locationUrl;
                    if (loc.hasOwnProperty('url')) {
                        url += loc.url;
                    } else {
                        url += parseFloat(loc.lat).toFixed(3) + 'N' + parseFloat(loc.lon).toFixed(3) + 'E';
                    }
                    if ('' !== url) {
                        window.open(url + '?utm_source=weather_widget&utm_medium=linkus&utm_content=three&utm_campaign=Weather%2BWidget');
                    }
                }
            });

            window.mb.search.overlay.setCallback(function () {
                window.mb.search.search.closeResults();
            });

            window.mb.search.search.subscribe('locationsearch.openResults', function () {
                window.mb.search.overlay.open();
            });

            window.mb.search.search.subscribe('locationsearch.closeResults', function () {
                window.mb.search.overlay.close();
            });

            if ('function' === typeof callback) {
                callback.apply();
            }
        })
    }
};

var proxy = function () {
    window.mb.search.proxy(function () {
        _gls.focus();
    });
    _gls.removeEventListener('click', proxy);
    return false;
};

var _gls = document.getElementById('gls');
_gls.addEventListener('click', proxy);

_gls.addEventListener('mouseover', function () {
    _gls.click();
});

if (_gls.value !== _gls.getAttribute('data-mbdescription')) {
    window.mb.search.proxy(function () {
        _gls.focus();
    });
}

var _gps = document.getElementById('gps');
_gps.addEventListener('click', function () {
    window.mb.search.proxy(function () {
        window.mb.search.wrapper.geolocate();
    });
});